"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://reference.opcfoundation.org/v104/Core/docs/Part6/A.1/
exports.AttributeIdInvalid = 0;
exports.AttributeIdNodeId = 1;
exports.AttributeIdNodeClass = 2;
exports.AttributeIdBrowseName = 3;
exports.AttributeIdDisplayName = 4;
exports.AttributeIdDescription = 5;
exports.AttributeIdWriteMask = 6;
exports.AttributeIdUserWriteMask = 7;
exports.AttributeIdIsAbstract = 8;
exports.AttributeIdSymmetric = 9;
exports.AttributeIdInverseName = 10;
exports.AttributeIdContainsNoLoops = 11;
exports.AttributeIdEventNotifier = 12;
exports.AttributeIdValue = 13;
exports.AttributeIdDataType = 14;
exports.AttributeIdValueRank = 15;
exports.AttributeIdArrayDimensions = 16;
exports.AttributeIdAccessLevel = 17;
exports.AttributeIdUserAccessLevel = 18;
exports.AttributeIdMinimumSamplingInterval = 19;
exports.AttributeIdHistorizing = 20;
exports.AttributeIdExecutable = 21;
exports.AttributeIdUserExecutable = 22;
exports.AttributeIdDataTypeDefinition = 23;
exports.AttributeIdRolePermissions = 24;
exports.AttributeIdUserRolePermissions = 25;
exports.AttributeIdAccessRestrictions = 26;
exports.AttributeIdAccessLevelEx = 27;
// https://reference.opcfoundation.org/v104/Core/docs/Part6/5.1.2/
exports.TypeIdNull = 0; // not part of specification but some servers (e.g. Prosys) return it anyway
exports.TypeIdBoolean = 1;
exports.TypeIdSByte = 2;
exports.TypeIdByte = 3;
exports.TypeIdInt16 = 4;
exports.TypeIdUint16 = 5;
exports.TypeIdInt32 = 6;
exports.TypeIdUint32 = 7;
exports.TypeIdInt64 = 8;
exports.TypeIdUint64 = 9;
exports.TypeIdFloat = 10;
exports.TypeIdDouble = 11;
exports.TypeIdString = 12;
exports.TypeIdDateTime = 13;
exports.TypeIdGUID = 14;
exports.TypeIdByteString = 15;
exports.TypeIdXMLElement = 16;
exports.TypeIdNodeID = 17;
exports.TypeIdExpandedNodeID = 18;
exports.TypeIdStatusCode = 19;
exports.TypeIdQualifiedName = 20;
exports.TypeIdLocalizedText = 21;
exports.TypeIdExtensionObject = 22;
exports.TypeIdDataValue = 23;
exports.TypeIdVariant = 24;
exports.TypeIdDiagnosticInfo = 25;
